export default __webpack_public_path__ + "static/media/cash-payment-sign.4ae4ef2a.svg";